import { render } from "./GridItem.vue?vue&type=template&id=bf5dd244"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=bf5dd244&lang=css"
script.render = render

export default script